import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  selectPublixInfo,
  selectPublixInfoPending,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  data: selectPublixInfo(state),
  loadingPublixInfo: selectPublixInfoPending(state),
});

export const enhance = compose(
  injectIntl,
  connect(mapStateToProps),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentPublixInfo/enhance.js